import { Options } from '@sheerid/jslib';
import { RecursivePartial } from './lib/types/types';


export const programId = '62fbac130c6efb6dc75989ad';

export const defaultOptions: RecursivePartial<Options> = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com/',
    },

    logLevel: 'error',
    useFingerprinting: true,
};
